import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { WindowRef } from './common/core/domain/window-ref';
import { GlobalErrorHandlerService } from './common/core/error/global-error-handler.service';
import { baseUrlInterceptor } from './common/core/http-interceptor/base-url.interceptor';
import { headerInterceptor } from './common/core/http-interceptor/header.interceptor';
import { loadingInterceptor } from './common/core/http-interceptor/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Without this, an error that RxJS reports as unhandled - every `subscribe` with no error
    // callback - reaches the window's 'error' event and never reaches `ErrorHandler`, so
    // GlobalErrorHandlerService never runs: no /forbidden on a 403, no alert on anything else.
    // Measured in the browser: the 403 from the product list arrived at window.onerror only.
    provideBrowserGlobalErrorListeners(),
    // Angular 22 defaults to 'always'; keep pre-v22 param inheritance behavior
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    provideHttpClient(withInterceptors(
      [headerInterceptor, baseUrlInterceptor, loadingInterceptor],
    )),
    WindowRef,
    GlobalErrorHandlerService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
  ]
};
